import { styled, component } from '../../utils/style';

export const ListPageWrapper = styled()(component.div, 'ListPageWrapper')`
    display: flex;
    flex-wrap: nowrap;
	flex-direction: column;
	height: 100%;
`;

export const DriveItemListActionButtons = styled()(component.div, 'DriveItemListActionButtons')`
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
	align-items: center;

	& > * > button > svg, & > * > svg {
		fill: ${props => props.theme.primary.iconsColor};
	}
`;

export const PageTitle = styled()(component.div, 'PageTitle')`
	padding: 9px 14px;
	line-height: 30px;
	color: ${props => props.theme.primary.strongColor};
	text-decoration: none;
	font-weight: 500;
`;

export const NoItemsContainer = styled()(component.div, 'NoItemsContainer')`
	display: flex;
	justify-content: center;
	margin-top: 20px;
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/styles.ts